import { defaultsDeep, get, has, isObject, kebabCase } from '../_';

export const propOrDefaultMixin = {
  methods: {
    propOrDefault(prop, defaultPath, strategy) {
      return this.passedProp(prop, get(this.$defaults, defaultPath), strategy);
    },
    passedProp(prop, fallback, strategy) {
      const rawProps = this.$?.vnode?.props || {};
      if (has(rawProps, prop) || has(rawProps, kebabCase(prop))) {
        const propValue = this[prop];
        if (isObject(propValue) && strategy === 'merge') {
          return defaultsDeep({}, propValue, fallback);
        }
        return propValue;
      }
      return fallback;
    },
  },
};
